import { useEffect, useState } from "react";
import axios from "axios";
import { UserX, ShieldCheck } from "lucide-react";
import { API } from "../App";

const AccountRow = ({ a }) => (
  <li className="text-xs text-[#475569] border-t border-[#F0ECF7] pt-2" data-testid={`purge-account-${a.user_id}`}>
    <strong>{a.label}</strong> · {a.role}{a.admin_role ? ` / ${a.admin_role}` : ""} · created {a.created_at?.slice(0, 10) || "unknown"}
    <div>Last login: {a.last_login_at || "never recorded"} · Audit entries: {a.audit_entries} · Reset link active: {a.active_reset_link ? "yes" : "no"} · Verify link pending: {a.pending_verification_link ? "yes" : "no"} · API keys: {a.api_keys}</div>
    <div>Permissions: {(a.permissions || []).join(", ") || "none"}</div>
  </li>
);

// Founder-only: results of the one-time blocked-domain account removal.
export const AccountPurgeReportCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API}/founder/account-purge-reports`).then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <div className="bg-white border border-[#E5DFEC] rounded-2xl p-5 mb-6" data-testid="account-purge-card">
      <div className="flex items-center gap-2 mb-2">
        <UserX className="w-4 h-4 text-[#6B4E8A]" />
        <h3 className="font-medium text-[#6B4E8A]">Blocked-domain account removal</h3>
      </div>
      {data.reports.length === 0 && <p className="text-sm text-[#64748B]" data-testid="purge-none">No removal has run on this database.</p>}
      {data.reports.map((r) => (
        <div key={r.ran_at} className="mb-3" data-testid="purge-report">
          <p className="text-sm text-[#475569]" data-testid="purge-summary">Ran {r.ran_at.slice(0, 16).replace("T", " ")} UTC · <strong>{r.accounts_removed}</strong> account(s) removed · {r.references_anonymized} reference(s) anonymized</p>
          <ul className="mt-2 space-y-2">{r.accounts.map((a) => <AccountRow key={a.user_id} a={a} />)}</ul>
        </div>
      ))}
      <div className="flex items-center gap-2 mt-3 mb-1"><ShieldCheck className="w-4 h-4 text-[#6B4E8A]" /><span className="text-sm font-medium text-[#6B4E8A]">Admin-level accounts now</span></div>
      <ul className="text-xs text-[#475569] space-y-1" data-testid="purge-admin-list">
        {data.admin_level_accounts_now.map((u) => <li key={u.user_id} data-testid={`purge-admin-${u.user_id}`}>{u.email} · {u.admin_role || u.role}{u.is_banned ? " · banned" : ""}</li>)}
      </ul>
    </div>
  );
};
